"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.025 5.24997C14.025 4.86337 14.3384 4.54997 14.725 4.54997C15.9814 4.54997 17 5.56853 17 6.82497V12.25C17 14.0173 15.5673 15.45 13.8 15.45H6.2C4.43269 15.45 3 14.0173 3 12.25L3 6.82497C3 5.56853 4.01855 4.54997 5.275 4.54997V5.94997C4.79175 5.94997 4.4 6.34172 4.4 6.82497L4.4 12.25C4.4 13.2441 5.20589 14.05 6.2 14.05H13.8C14.7941 14.05 15.6 13.2441 15.6 12.25V6.82497C15.6 6.34172 15.2082 5.94997 14.725 5.94997C14.3384 5.94997 14.025 5.63657 14.025 5.24997Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.44995 5.24997C4.44995 4.86337 4.76335 4.54997 5.14995 4.54997H5.25C5.6366 4.54997 5.95 4.86337 5.95 5.24997C5.95 5.63657 5.6366 5.94997 5.25 5.94997H5.14995C4.76335 5.94997 4.44995 5.63657 4.44995 5.24997Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.0528 2.10001C10.2407 2.10181 10.4201 2.17914 10.5504 2.31458L12.9044 4.76062C13.1725 5.03917 13.164 5.48231 12.8855 5.75038C12.6069 6.01846 12.1638 6.00996 11.8957 5.73141L10.746 4.53683V9.30735C10.746 9.69395 10.4326 10.0073 10.046 10.0073C9.65945 10.0073 9.34605 9.69395 9.34605 9.30735V4.48995L8.09503 5.74098C7.82167 6.01435 7.37845 6.01436 7.10508 5.74099C6.83172 5.46763 6.83171 5.02441 7.10508 4.75104L9.55107 2.30501C9.68399 2.17208 9.86478 2.09821 10.0528 2.10001Z",
  fill: "currentColor"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=CardMoveUp20.js.map